<template>
    <v-row 
        v-if="loading"
        align="center"
        justify="center">
         <v-col
          cols="12"
          sm="8"
          md="4">
          <v-card flat color="transparent">
            <v-card-text class="pb-0">
                <p class="text-center"><img src="../assets/logo-large.png" /></p>
                <v-row align="center" justify="center">
                    <v-col cols="10">
                        <p class="text-center">
                            <v-progress-linear
                                indeterminate
                                color="primary"
                                height="5"
                                class="mt-5"
                                rounded
                            ></v-progress-linear>
                        </p>
                    </v-col>
                </v-row>
            </v-card-text>
          </v-card>
        </v-col>
    </v-row>
    <v-row 
        v-else
        align="center"
        justify="center"
    >
        <v-col
            cols="12"
            sm="7"
            md="5"
            lg="4"
        >
            <v-card outlined>
                <v-card-title class="px-5 mb-n2">
                    Choose a business profile
                </v-card-title>
                <v-card-text>
                    <v-list class="mb-2" nav>
                        <template v-for="permission in loggedInUsersPermissions">
                            <v-list-item v-if="permission.businessName != ''" :key="permission.businessProfileId"  @click.stop="handleSwitchTo(permission.businessProfileId)">
                                <UserAvatar :usersInitials="permission.businessName[0]" />
                                <v-list-item-content>
                                    <v-list-item-title>{{ permission.businessName }}</v-list-item-title>
                                    <v-list-item-subtitle><v-icon class="grey--text" size="14">mdi-map-marker</v-icon> {{ permission.country }}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                    </v-list>
                    <v-divider/>
                    <v-btn @click="handleCreateNewBusinessProfile" class="mt-4" text block large>
                         <v-icon class="mr-4">mdi-briefcase-plus-outline</v-icon>New Business Profile
                    </v-btn>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import UserAvatar from '@/components/UserAvatar'
import {addBusinessPortalStatsDoc, addBusinessProfilesDoc, setBusinessPortalStatsDoc} from "@/shared/firebase_utils";

export default {
    data() {
        return {
            loading: true,
        }
    },
    computed: mapGetters(['loggedInUsersPermissions', 'userProfile', 'loggedInUsersUid']),
    components: {
        UserAvatar,
    }, 
    async created() {
        console.log('Business Accounts created called');
        let createNew = this.$route.query.create || false;
        let switchToBusinessProfileId = this.$route.query.switchToBusinessProfileId || '';

        if (switchToBusinessProfileId != '') {
            let i = 0; 
            for(i=0; i < this.loggedInUsersPermissions.length; i++) {
                if(this.loggedInUsersPermissions[i].businessProfileId == switchToBusinessProfileId) {
                    await this.updateSelectedBusinessProfileId(switchToBusinessProfileId);
                    this.$router.push('/');
                }
            }
        }
        
        if(this.loggedInUsersPermissions.length == 0 || createNew) {
            await this.handleCreateNewBusinessProfile();
        } else if(this.loggedInUsersPermissions.length == 1) {
            await this.updateSelectedBusinessProfileId(this.loggedInUsersPermissions[0].businessProfileId);
            this.$router.push('/');
        }
        this.loading = false;
    },
    methods: {
        ...mapActions(['updateSelectedBusinessProfileId','initializeUserProfile']),
        async createNewBusinessAccount() {
            try {

                //Add a new business profile document
                let businessProfileDocRef = await addBusinessProfilesDoc({
                    isBusinessPortalOnboarded: false,
                    isBusinessCardDesignAdded: false,
                    isBusinessCardInformationAdded: false,
                    multiConnectCredits: 6
                });
                let newBusinessProfileId = businessProfileDocRef.id;
                //Add a new business portal stats document
                await setBusinessPortalStatsDoc(newBusinessProfileId,{
                    noOfCardholders: 0, 
                    noOfConnections: 0, 
                    noOfNewNotifications: 0, 
                    isNewNotifications: false,
                    noOfIosUsers: 0,
                    noOfAndroidUsers: 0,
                });
                //Provide the logged-in user admin access to the newly created business profile
                await addBusinessPortalStatsDoc({
                    firstName: this.userProfile.firstName,
                    lastName: this.userProfile.lastName,
                    email: this.userProfile.email.toLowerCase(),
                    businessProfileId: newBusinessProfileId,
                    status: 'active',
                    privilegeLevel: 'admin',
                    uid: this.loggedInUsersUid,
                    businessName: '',
                    country: '',
                });
                return newBusinessProfileId;
            } catch(error) {
                console.log(error);
            }
        },
        async handleSwitchTo(switchToBusinessProfileId) {
            this.loading = true;
            await this.updateSelectedBusinessProfileId(switchToBusinessProfileId);
            this.$router.push('/');
            this.loading = false;
        },
        async handleCreateNewBusinessProfile() {
            this.loading = true;
            let newBusinessProfileId = await this.createNewBusinessAccount();
            await this.updateSelectedBusinessProfileId(newBusinessProfileId);
            this.$router.replace('/subscribe/0');
            this.loading = false;
        }
    }
}
</script>